import { factoryService, getFileRequest, getJsonRequest, postJsonRequest } from '@chilecompra/react-kit'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import { makeUrlWithParams } from '../modules/utils/services'
import { IS_MANUAL_CREATE_PROCESS } from '../config/settings/constants'

/**
 * Get the participants list.
 * @param id string
 */
export const getParticipantsList = factoryService(({ fields }) => {
  const finalUrl = makeUrlWithParams({ ...fields })
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/masprobidad-lectura/participante/numeroproceso?${finalUrl}`)
})

/**
 * Get participant list download file.
 */
export const getParticipantListDownloadFile = factoryService(({ externalCode }) => {
  return getFileRequest(`${REACT_APP_API_BASE_URL}/v1/masprobidad-lectura/participante/descargarexcel/${externalCode}`)
})

/**
 * Get the participants list process
 */
export const getParticipantsListProcess = factoryService(() => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/masprobidad-lectura/proceso`)
})

/**
 * Get function by process
 * @param id string
 */
export const getFunctionByProcess = factoryService(({ id }) => {
  return getJsonRequest(`
    ${REACT_APP_API_BASE_URL}/v1/masprobidad-lectura/funcion/funcionproceso?idProceso=${id}&gestionProceso=M
  `)
})

/**
 * Get dni data
 * @param dni string
 */
export const getDniData = factoryService(({ dni }) => {
  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/masprobidad-lectura/participante/registrocivil/${dni}`)
})

/**
 * Get dni data
 * @param dni string
 */
export const getInfoPerson = factoryService(({ dni }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/masprobidad-lectura/participante/info-persona?rut=${dni}`)
})

/**
 * Get the participants list.
 * @param id string
 */
export const getParticipantsListPaginate = factoryService(({ fields }) => {
  const finalUrl = makeUrlWithParams({ ...fields })
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/masprobidad-lectura/detalleparticipante?${finalUrl}`)
})

/**
 * Send the participants data.
 * @param body object
 */
export const sendParticipantData = factoryService(({ body }) => {
  const {
    selectedFullName,
    selectedRole,
    selectedDni,
    selectedEmail,
    functionIdSelected,
    processIdSelected,
    participantId,
    processId,
    isForeignPerson,
    orgCode,
    isOfficialOfInstitution,
    startDate,
    endDate
  } = body
  const payload = {
    nombreApellido: selectedFullName,
    cargo: selectedRole,
    rut: selectedDni,
    email: selectedEmail,
    orgCode,
    esExtranjero: !isForeignPerson || isForeignPerson === 0 ? 0 : 1,
    esFuncionario: !isOfficialOfInstitution || isOfficialOfInstitution === 0 ? 0 : 1,
    participanteId: participantId || null,
    funcionId: functionIdSelected,
    proceso: {
      procesoId: processIdSelected,
      codigoProceso: processId
    },
    procesoAsociados: [],
    esRegistroManual: IS_MANUAL_CREATE_PROCESS,
    fechaInicio: startDate,
    fechaFin: endDate
  }
  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/masprobidad-escritura/participante/agregar`, { body: payload })
})

/**
 * Send the participants data.
 * @param body object
 */
export const sendParticipantDataEdited = factoryService(({ body }) => {
  const {
    fullNameValue,
    roleValue,
    dniValue,
    emailValue,
    isForeignPerson,
    participantId,
    participantDetailId,
    selectedFunction: { name: functionName, value: functionId },
    selectedProcess: { name: processName, value: processId },
    functionProcessChanged,
    startDate,
    endDate,
    isManual,
    participantProcessId
  } = body
  const payload = {
    detalleParticipanteid: participantDetailId,
    participanteId: participantId,
    nombreApellido: fullNameValue,
    cargo: roleValue,
    rut: dniValue,
    email: emailValue,
    esExtranjero: !isForeignPerson || isForeignPerson === 0 ? 0 : 1,
    idFuncion: functionId,
    nombreFuncion: functionName,
    idProceso: processId,
    nombreProceso: processName,
    fpSeleccionado: functionProcessChanged,
    fechaInicio: startDate,
    fechaFin: endDate,
    esResgistroManual: isManual,
    procesoParticipanteId: participantProcessId
  }
  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/masprobidad-escritura/participante/editar`, { body: payload })
})
